import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { RouteErrorBoundary } from "@/components/common/RouteErrorBoundary";

import { SupplierShell } from "./SupplierShell";

/**
 * Layout route for the authenticated supplier portal.
 *
 * The shell mounts ONCE and only the <Outlet/> swaps, so navigating between
 * the board and an order never re-runs the auth check or re-animates the nav.
 * A render crash inside a page is caught here and leaves the shell usable.
 */
export const SupplierLayout = () => {
  const { pathname } = useLocation();
  return (
    <SupplierShell>
      <RouteErrorBoundary resetKey={pathname}>
        <Suspense
          fallback={
            <div className="flex min-h-[40vh] flex-1 items-center justify-center">
              <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" aria-label="Loading" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </RouteErrorBoundary>
    </SupplierShell>
  );
};

export default SupplierLayout;
